export const SET_WORK_FLOW_ROLES = "SET_WORK_FLOW_ROLES"
export const SET_WORK_FLOW_STAFF_ROLES = "SET_WORK_FLOW_STAFF_ROLES"
export const SET_WORK_FLOW_TYPE = "SET_WORK_FLOW_TYPE"
export const WORKFLOW = "WORKFLOW"
export const TEMPLATE = "TEMPLATE"
export const GET_BUSINESS_ROLE_AND_STAFF = "GET_BUSINESS_ROLE_AND_STAFF"
export const GET_REMARK_ROLE_AND_STAFF = "GET_REMARK_ROLE_AND_STAFF"
